import { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'next-i18next';
import { useDirectMessageNavigation } from 'src/components/DirectMessage/context';
import GenericButton from 'src/components/GenericButton';
import { EVENT_NAME, EVENT_TYPE } from 'src/types/Event';
import { pushEvent } from 'src/utils/event-gateway';
const EmptyContainer = styled.div`
  flex: 1;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
`;
type Props = Pick<ComponentProps<'div'>, 'className'>;
const RoomListEmpty = (props: Props) => {
  const {
    t
  } = useTranslation();
  const {
    openMatch
  } = useDirectMessageNavigation();
  const handleClickButton = () => {
    pushEvent({
      eventType: EVENT_TYPE.LOG,
      eventName: EVENT_NAME.MESSAGE__CLICK_GO_MEET_FRIEND,
      eventParams: {
        action_category: 'click',
        tab: 'message',
        page: 'main',
        target: 'go_meet_friend'
      }
    });
    openMatch();
  };
  return <EmptyContainer {...props} data-sentry-element="EmptyContainer" data-sentry-component="RoomListEmpty" data-sentry-source-file="Empty.tsx">
      <GenericButton type='button' size='large' variant='primary' onClick={handleClickButton} data-sentry-element="GenericButton" data-sentry-source-file="Empty.tsx">
        {t('message_list_emptycase_empty_button')}
      </GenericButton>
    </EmptyContainer>;
};
export default RoomListEmpty;